module.exports = __webpack_public_path__ + "static/media/bus-icon-map.e327514a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/bus-icon-map.svg
// module id = 670
// module chunks = 0